import { Checkbox, ModalProps, message } from "antd";
import {
  GET_PRODUCT_SURPLUS_URL,
  MARK_SURPLUS_SOLD_OUT,
  MARK_SURPLUS_VARIANT_SOLD_OUT,
} from "../../../commons/constants/api-urls";
import useFetch from "../../../commons/hooks/useFetch";
import defaultAxios from "../../../commons/utils/axios";
import CustomModal from "../../../commons/components/CustomModal/CustomModal";
import styles from "./SoldOutFormPopup.module.scss";
import { useEffect, useState } from "react";
import ImageDisplay from "../../../commons/components/ImageDisplay";
import { useParams } from "react-router-dom";
import { SURPLUS_STATUS } from "../../../commons/constants/surplus";

interface SoldOutPopupProps extends ModalProps {
  className?: string;
  title: string;
  description: string;
  surplus: Surplus;
  onRefetch: () => void;
}

export default function SoldOutFromPopup({
  className,
  title,
  description,
  surplus,
  onRefetch,
  ...modalProps
}: SoldOutPopupProps) {
  const { storeId } = useParams<{ storeId: string }>();
  const { data, refresh, loading } = useFetch<any>(surplus.id && GET_PRODUCT_SURPLUS_URL(storeId || "", surplus.id));
  const [checkAll, setCheckAll] = useState(false);
  const [loadingCheckBox, setLoadingCheckBox] = useState(false);

  useEffect(() => {
    surplus && setCheckAll(surplus.isSoldOut ?? false);
  }, [surplus, surplus?.isSoldOut, refresh]);

  const handleSelectAll = async (event: any) => {
    const isChecked = event.target.checked;
    try {
      setLoadingCheckBox(true);
      await defaultAxios.put(MARK_SURPLUS_SOLD_OUT(storeId || "", surplus.id), {
        status: isChecked ? SURPLUS_STATUS.SOLD_OUT : SURPLUS_STATUS.ACTIVE,
      });
      setCheckAll(isChecked);
      message.success(`Successfully`);
      refresh();
      onRefetch();
      setLoadingCheckBox(false);
    } catch (error) {
      event.target.checked = !isChecked;
      message.error(`Mark surplus sold out failed`);
      setLoadingCheckBox(false);
    }
  };

  const handleSelect = async (event: any) => {
    const isChecked = event.target.checked;
    const value = event.target.value;
    try {
      setLoadingCheckBox(true);
      await defaultAxios.put(MARK_SURPLUS_VARIANT_SOLD_OUT(storeId || "", surplus.id, value), {
        isSoldOut: `${isChecked}`,
      });
      message.success(`Successfully`);
      // refresh();
      setLoadingCheckBox(false);
    } catch (error) {
      event.target.checked = !isChecked;
      message.error(`Mark item sold out failed`);
      setLoadingCheckBox(false);
    }
  };

  return (
    <CustomModal className={styles.soldOutPopup} {...modalProps}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      {surplus && (
        <div className={styles.surplusForm}>
          <div className={`${styles.formHeader} ${checkAll ? styles.checkAllFormHeader : ""}`}>
            <Checkbox defaultChecked={surplus?.isSoldOut || false} value={surplus.id} onChange={handleSelectAll} />
            <div className={styles.imageWrapper}>
              <ImageDisplay src={surplus.imageUrl || ""} alt="" />
            </div>
            <div>{surplus.name}</div>
          </div>
          <div className={`${styles.formBody} ${checkAll ? styles.checkAllFormBody : ""}`}>
            {!checkAll &&
              data &&
              data.attributes.map(
                (att: any, index: number) =>
                  att.attribute !== "default" && (
                    <div className={styles.attributeWrapper} key={index}>
                      <h3>{att.attribute}</h3>
                      <div style={{ width: "100%", display: "block" }}>
                        {att.variants.map((variant: any) => (
                          <div className={styles.checkBoxGroupWrapper}>
                            <Checkbox
                              defaultChecked={variant.isSoldOut}
                              value={variant.id}
                              onChange={handleSelect}
                              className={styles.checkBox}
                              disabled={loadingCheckBox || loading}
                            >
                              {variant.variant}
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
              )}
          </div>
        </div>
      )}
    </CustomModal>
  );
}
